import {
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_DELAYED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CANCELLED,
} from '../../services/constants';

export const statuses: Record<string, string> = {
  [ORDER_STATUS_IN_PROGRESS]: 'in_progress',
  [ORDER_STATUS_DELAYED]: 'delayed',
  [ORDER_STATUS_COMPLETED]: 'complete',
  [ORDER_STATUS_CANCELLED]: 'cancelled',
};

export const statusesText: Record<string, string> = {
  [ORDER_STATUS_IN_PROGRESS]: 'In Progress',
  [ORDER_STATUS_DELAYED]: 'Delayed',
  [ORDER_STATUS_COMPLETED]: 'Completed',
  [ORDER_STATUS_CANCELLED]: 'Cancelled',
};
